import {
  Box,
  Grid2,
  InputAdornment,
  Paper,
  TextField,
  Typography
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useFormStyles } from "../../../hooks";
import { InterpretationPreview } from "../../../types/interfaces/file/imports/flowTestInterpretations";

interface UploadInterpretationFormProps {
  interpretation: InterpretationPreview;
  variableName: string;
  variableUnit: string;
  interpretationMethodName: string;
}

export const UploadInterpretationForm = ({
  interpretation,
  variableName,
  variableUnit,
  interpretationMethodName,
}: UploadInterpretationFormProps) => {
  const { t } = useTranslation();
  const formStyles = useFormStyles(true);

  return (
    <Box>
      <Grid2 container spacing={3}>
        <Grid2 size={12}>
          <Paper sx={{ p: 3, borderRadius: 2 }}>
            <Typography variant="h6" mb={2}>
              {t("flow-tests.flow-test-interpretation.title")}
            </Typography>
            <Grid2 container spacing={2}>

              <Grid2 size={{ xs: 12, md: 3 }}>
                <TextField
                  fullWidth
                  label={t("flow-tests.flow-test-interpretation.measured-capture")}
                  value={interpretation.measuredCaptureIdentifier}
                  disabled
                  sx={{ ...formStyles }}
                />
              </Grid2>

              <Grid2 size={{ xs: 12, md: 3 }}>
                <TextField
                  fullWidth
                  label={t("flow-tests.flow-test-interpretation.interpretation-method")}
                  value={interpretationMethodName}
                  disabled
                  sx={{ ...formStyles }}
                />
              </Grid2>

              <Grid2 size={{ xs: 12, md: 3 }}>
                <TextField
                  fullWidth
                  label={t("flow-tests.flow-test-interpretation.variable")}
                  value={variableName}
                  disabled
                  sx={{ ...formStyles }}
                />
              </Grid2>

              <Grid2 size={{ xs: 12, md: 3 }}>
                <TextField
                  fullWidth
                  label={t("flow-tests.flow-test-interpretation.value")}
                  value={interpretation.value}
                  disabled
                  sx={{ ...formStyles }}
                  slotProps={{
                    input: {
                      startAdornment: interpretation.flag
                        ? <InputAdornment position="start">{interpretation.flag}</InputAdornment>
                        : undefined,
                      endAdornment: <InputAdornment position="end">{variableUnit}</InputAdornment>
                    },
                  }}
                />
              </Grid2>

              <Grid2 size={12}>
                <TextField
                  fullWidth
                  label={t("flow-tests.flow-test-interpretation.notes")}
                  value={interpretation.notes ?? ""}
                  disabled
                  multiline
                  minRows={3}
                  sx={{ ...formStyles }}
                />
              </Grid2>
            </Grid2>
          </Paper>
        </Grid2>
      </Grid2>
    </Box>
  );
};